const windowsteps = {
    stepswithoutENG: [
        {
          target: '.v-step-0',
          content: 'Click to go back to the project list.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Click to create a new window`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Enter text here to filter the window list',
          params: {
            placement: 'left'
          }
        },
      ],
    stepswithENG: [
        {
          target: '.v-step-0',
          content: 'Click to go back to the project list.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Click to create a new window`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Enter text here to filter the window list',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-3',
          content: 'This is the name of the window.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-4',
          content: 'This is the number of identical windows.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-5',
          content: 'Click to edit the window parameters.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-6',
          content: 'Click to make a copy of a window.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-7',
          content: 'Click to delete a window.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-8',
          content: 'Scaled representation of the window with hinges, handle, width, height and weight information.',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-9',
          content: 'Set or bulk.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-10',
          content: 'Chrono type.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-11',
          content: 'Hinge type.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-12',
          content: 'Handle type and partnumber.',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-13',
          content: 'Click to see the BOM for the window.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-14',
          content: 'Click to generate the .PDF file with mounting instructions. The .PDF file is stored in your Downloads folder.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-15',
          content: 'Click to generate the generic mounting file.PDF for the selected configuration. The .PDF file is stored in your Downloads folder.',
          params: {
            placement: 'bottom'
          }
        },
      ],
      stepswithoutNED: [
        {
          target: '.v-step-0',
          content: 'Klik om terug te keren naar de lijst van projecten.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Klik om een nieuw raam te maken.`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Typ tekst om de ramenlijst te filteren.',
          params: {
            placement: 'left'
          }
        },
      ],
    stepswithNED: [
        {
          target: '.v-step-0',
          content: 'Klik om terug te keren naar de lijst van projecten.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Klik om een nieuw raam te maken.`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Typ tekst om de ramenlijst te filteren.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-3',
          content: 'Dit is de naam van het raam.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-4',
          content: 'Dit is het aantal identieke ramen.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-5',
          content: 'Klik om de raamparameters te wijzigen.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-6',
          content: 'Klik om een kopie te maken van een raam.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-7',
          content: 'Klik om een raam te verwijderen.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-8',
          content: 'Geschaalde afbeelding van een raam met scharnieren, kruk, vleugelbreedte(s), vleugelhoogte en vleugelgewicht(en).',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-9',
          content: 'Set of grootverpakking.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-10',
          content: 'Chronotype.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-11',
          content: 'Scharniertype.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-12',
          content: 'Kruktype en artikelnummer.',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-13',
          content: 'Klik om de BOM voor een raam te tonen.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-14',
          content: 'Klik om een .PDF bestand te genereren met montage instructies. Het .PDF bestand wordt in uw Downloads folder bewaard.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-15',
          content: 'Klik om een .PDF bestand te genereren met de generieke montagetekening voor de gekozen configuratie. Het .PDF bestand wordt in uw Downloads folder bewaard.',
          params: {
            placement: 'bottom'
          }
        },
      ],
      stepswithoutCHI: [
        {
          target: '.v-step-0',  // We're using document.querySelector() under the hood
          content: '单击此按钮返回项目列表',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: '单击此按钮创建新的窗型',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: '在此输入文本可筛选项目列表',
          params: {
            placement: 'left'
          }
        },
      ],
    stepswithCHI: [
        {
          target: '.v-step-0',  // We're using document.querySelector() under the hood
          content: '单击此按钮返回项目列表',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: '单击此按钮创建新的窗型',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: '在此输入文本可筛选项目列表',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-3',
          content: '窗型编号',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-4',
          content: '相同窗型的数量',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-5',
          content: '单击此按钮可编辑窗型参数',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-6',
          content: '单击此按钮可复制窗型',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-7',
          content: '单击此按钮可删除窗型',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-8',
          content: '缩放窗口可显示窗型的铰链、执手、宽度、高度和重量信息',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-9',
          content: '套件或散件大包装',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-10',
          content: 'Chrono锁闭类型',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-11',
          content: '铰链类型',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-12',
          content: '执手类型和编号',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-13',
          content: '单击此按钮查看窗型的物料清单',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-14',
          content: '单击此按钮可生成 .PDF安装说明。.PDF文件存储在下载文件夹中',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-15',
          content: '单击此按钮可生成所选配置的 .PDF安装说明。.PDF文件存储在下载文件夹中',
          params: {
            placement: 'bottom'
          }
        },
      ],
      stepswithoutPOR: [
        {
          target: '.v-step-0',
          content: 'Carregue para voltar à listagem de projetos.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Carregue para criar uma nova janela.`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Insira o texto a pesquisar na lista de projetos.',
          params: {
            placement: 'left'
          }
        },
      ],
    stepswithPOR: [
        {
          target: '.v-step-0',
          content: 'Carregue para voltar à listagem de projetos.',
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-1',
          content: `Carregue para criar uma nova janela.`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '.v-step-2',
          content: 'Insira o texto a pesquisar na lista de projetos.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-3',
          content: 'Nome da janela.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-4',
          content: 'Número de janelas com a mesma configuração.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-5',
          content: 'Carregue para editar os parâmetros da janela.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-6',
          content: 'Carregue para criar uma cópia da janela.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-7',
          content: 'Carregue para eliminar a janela.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-8',
          content: 'Representação à escala da janela com dobradiças, puxador, largura, altura e informação de peso.',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-9',
          content: 'Em kit ou formato industrial',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-10',
          content: 'Tipologia Chrono.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-11',
          content: 'Tipologia de dobradiça.',
          params: {
            placement: 'left'
          }
        },
         {
          target: '.v-step-12',
          content: 'Tipologia de puxador e referência.',
          params: {
            placement: 'left'
          }
        },
        {
          target: '.v-step-13',
          content: 'Carregue para ver a BOM da janela.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-14',
          content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem. O ficheiro .PDF será guardado na pasta de Transferências.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '.v-step-15',
          content: 'Carregue para gerar um ficheiro .PDF com as instruções de montagem gerais do sistema. O ficheiro .PDF será guardado na pasta de Transferências.',
          params: {
            placement: 'bottom'
          }
        },
      ],
    }

    export default windowsteps


// WEBPACK FOOTER //
// ./src/ClientApp/helpers/window-steps.js